import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'cream' | 'white' | 'teal';
}
export function Section({
  children,
  className = '',
  id,
  background = 'cream'
}: SectionProps) {
  const bgColors = {
    cream: 'bg-[#EFF6FF]',
    white: 'bg-white',
    teal: 'bg-[#DBEAFE] text-[#1F2937]'
  };
  return <section id={id} className={`py-16 md:py-24 ${bgColors[background]} ${className}`} data-id="element-216">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-217">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-218">
          {children}
        </motion.div>
      </div>
    </section>;
}